var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDifferences = function SvgDifferences(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4C14 3.44772 14.4477 3 15 3H21V9C21 9.55228 20.5523 10 20 10C19.4477 10 19 9.55228 19 9V6.42711C18.1259 7.31619 16.79 8.64012 15.2406 9.85054C13.214 11.4338 10.6081 13 8 13H2.5C1.94772 13 1.5 12.5523 1.5 12C1.5 11.4477 1.94772 11 2.5 11H8C9.8919 11 12.036 9.81618 14.0094 8.27449C15.4801 7.1255 16.7366 5.87633 17.5977 5L15 5C14.4477 5 14 4.55228 14 4ZM14.0094 15.7255C13.1005 15.0155 12.1555 14.3814 11.2156 13.9039C11.9924 13.6264 12.7385 13.27 13.4407 12.874C14.0768 13.2761 14.6808 13.7121 15.2407 14.1495C16.79 15.3599 18.1259 16.6838 19 17.5729V15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15V21H15C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19H17.5977C16.7365 18.1237 15.4801 16.8745 14.0094 15.7255Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDifferences);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/differences.dce8a21a05fdd74c24c681c86a6d64f8.svg";